/**
 * @generated SignedSource<<f9c499b3f321171bf4ebfa6baa934dab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IndustryField_User$data = {
  readonly profile: {
    readonly industry: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "IndustryField_User";
};
export type IndustryField_User$key = {
  readonly " $data"?: IndustryField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"IndustryField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IndustryField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Industry",
          "kind": "LinkedField",
          "name": "industry",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b2ead3835c2efc2c5851c8f604fc3086";

export default node;
